import React from 'react';
import { QuestionForm } from '@catalogo/ui-americanas-desktop-product-form/src/components/organisms/QuestionForm';
import { Title, Wrapper, Hr, ButtonDesk } from './style';
import { MakeQuestionsBottomProps } from '../../../types';

export const MakeQuestionsBottom = (props: MakeQuestionsBottomProps) => {
  const { productId, product, config, dispatchMetrics, isDesk } = props;

  const ButtonForm = isDesk ? (
    <ButtonDesk href={`/perguntar/${productId}`}>Faça uma pergunta</ButtonDesk>
  ) : (
    <QuestionForm
      className="text1"
      productId={productId}
      config={config}
      product={product}
      dispatchMetrics={dispatchMetrics}
      metricParams={{
        category: 'qna-pdp',
        action: 'fazer-pergunta',
        label: 'final-area-qna',
      }}
    >
      Faça uma pergunta
    </QuestionForm>
  );

  return (
    <Wrapper isDesk={isDesk}>
      <Hr isDesk={isDesk} />
      <Title isDesk={isDesk}>Não encontrou o que procurava?</Title>
      {ButtonForm}
    </Wrapper>
  );
};

export default MakeQuestionsBottom;
